/* global axios */
import ApiClient from './ApiClient';

class TelegramInternalApi extends ApiClient {
  constructor() {
    super('telegram_internal', { accountScoped: true });
  }

  getSettings() {
    return axios.get(`${this.url}/settings`);
  }

  updateSettings(payload) {
    return axios.patch(`${this.url}/settings`, payload);
  }

  getQueue({ inboxId } = {}) {
    return axios.get(`${this.url}/queue`, {
      params: { inbox_id: inboxId },
    });
  }

  closeQueueItem(conversationId) {
    return axios.post(`${this.url}/queue/${conversationId}/close`);
  }

  resetQueue() {
    return axios.post(`${this.url}/queue/reset`);
  }

  getReports({ since, until } = {}) {
    return axios.get(`${this.url}/reports`, {
      params: { since, until },
    });
  }

  getAudits({ eventName, userId, since, until, limit } = {}) {
    return axios.get(`${this.url}/audits`, {
      params: {
        event_name: eventName,
        user_id: userId,
        since,
        until,
        limit,
      },
    });
  }
}

export default new TelegramInternalApi();
